import React, { useRef, useState, useEffect } from "react";
import "./doctorSpecialization.css";
import EditSpeciality from "../addDepartment/editSpeciality";
import ToastPopup from "../../widgets/Toast/toastPopup";
import Widgets from "../../widgets";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toggleActiveDepartment } from "../../modules/department/departmentThunk";
import { resetToggleActiveDept } from "../../modules/department/departmentSlice";

const EditDepartment = ({ setSelectedView, department, isEdit }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { toggleActiveDept, toggleActiveDeptError } = useSelector((state) => state.department);
  const breadcrumbs = ["video_Consultation", "departments"];
  const paths = [{ path: "/department", onClick: () => setSelectedView("doctorSpecialization") }, "/department"];
  const editSpecialityRef = useRef();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    if (toggleActiveDeptError) {
      ToastPopup.error(toggleActiveDeptError);
      setSelectedView("doctorSpecialization");
    }
    if (toggleActiveDept && toggleActiveDept.status === "success" && toggleActiveDept.data.department.isActive) {
      const depName = toggleActiveDept.data.department.departmentName.en;
      ToastPopup.success(t("departmentActivated", { depName }));
      setSelectedView("doctorSpecialization");
    } else if (toggleActiveDept && !toggleActiveDept.data.department.isActive) {
      ToastPopup.success(t("departmentDeleted"));
      setSelectedView("doctorSpecialization");
    }
    dispatch(resetToggleActiveDept());
  }, [toggleActiveDept, toggleActiveDeptError]);

  const handleCancel = () => {
    setSelectedView("doctorSpecialization");
  };

  const handleSave = () => {
    if (editSpecialityRef.current) {
      editSpecialityRef.current.saveSpeciality();
    }
  };

  const truncateText = (text) => {
    if (text.length > 40) {
      return text.slice(0, 40) + "...";
    }
    return text;
  };

  const handleDelete = () => {
    setShowDeleteModal(true);
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
  };

  const handleConfirmDelete = () => {
    setShowDeleteModal(false);
    dispatch(toggleActiveDepartment(department._id));
  };

  return (
    <div className="department-box">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="department-heading-row">
        <div className="department-heading">{truncateText(department.departmentName.en)}</div>
        {department.isActive ? (
          <div className="department-del-btn" onClick={handleDelete}>
            {t("deactivate")}
          </div>
        ) : (
          <div className="department-update-btn" onClick={handleDelete}>
            {t("activate")}
          </div>
        )}
      </div>
      <div className="department-speciality-box">
        <div className="speciality-head">
          <div className="speciality-name">
            {t("specialityen")}
            <span className="astrik">*</span>
          </div>
          <div className="speciality-name">
            {t("specialityvn")}
            <span className="astrik">*</span>
          </div>
        </div>
        <div className="add-speciality">
          <EditSpeciality ref={editSpecialityRef} department={department} isEdit={isEdit} setSelectedView={setSelectedView} />
        </div>
        <div className="save-speciality add-department-btn">
          <div className="speciality-cancel" onClick={handleCancel}>
            {t("cancel")}
          </div>
          {department.isActive && (
            <div className="speciality-save" onClick={handleSave}>
              {t("save")}
            </div>
          )}
        </div>
      </div>
      <Widgets.ConfirmModal
        showModal={showDeleteModal}
        handleCancel={handleCancelDelete}
        handleConfirm={handleConfirmDelete}
        heading={department.isActive ? "cnfDepDel" : "cnfActivateHead"}
        description={department.isActive ? "askDelete" : "askActivate"}
        postive={!department.isActive}
      />
    </div>
  );
};

export default EditDepartment;
